function initEventsMap () {
    // Equivalent of $('.event-single [data-map]')
    var mapElements = document.querySelectorAll('.event-single [data-map]');

    mapElements.forEach(function(mapEl) {
        var lat = parseFloat(mapEl.getAttribute('data-lat'));
        var lng = parseFloat(mapEl.getAttribute('data-lng'));

        var position = {
            lat: lat,
            lng: lng
        };

        var zoom = parseInt(mapEl.getAttribute('data-zoom'), 10);

        var config = {
            center: position,
            zoom: zoom
        };

        // Equivalent of mapEl.is('[data-directions]')
        if (mapEl.hasAttribute('data-directions')) {
            config.disableDefaultUI = true;

            // Equivalent of mapEl.click(...)
            mapEl.addEventListener('click', function() {
                window.open('https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(position.lat + ',' + position.lng));
            });
        }

        var map = new google.maps.Map(mapEl, config);

        var marker = new google.maps.Marker({
            position: position,
            map: map
        });
    });
}



$.noConflict();
jQuery( document ).ready(function( $ ) {